webpackJsonp([112856403499745],{

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Videos = __webpack_require__(111);
	
	var _Videos2 = _interopRequireDefault(_Videos);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Videos2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Purpose'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Written documentation is only helpful to a point. Somethings are better explain with moving pictures.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Collects all the videos that have been created in a single location. Some of these videos may be linked elsewhere in the site.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-videos-index-js-79f101322cd46b865220.js